import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseCreateUserConfirmAlert.module.scss';

interface Props {
  className?: string;
}

const PurchaseCreateUserConfirmAlert = ({
  className,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseCreateUserConfirmAlert, className);

  return (
    <div className={classes}>
      <p className={css.PurchaseCreateUserConfirmAlert__Paragraph}>
        <FormattedMessage
          id="purchases.purchaseCreateUserConfirmAlert.message"
          values={{
            terms: (
              <Link href={'/terms'} prefetch={false}>
                <a
                  className={css.PurchaseCreateUserConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({
                    id: 'purchases.purchaseCreateUserConfirmAlert.termOfUse',
                  })}
                </a>
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(PurchaseCreateUserConfirmAlert);
